/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Find_BodyInputs */

const en_how_page_find_body = /** @type {(inputs: How_Page_Find_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainers, dieticians and physios with their next free hours. You do not need an account to look around.`)
};

const pl_how_page_find_body = /** @type {(inputs: How_Page_Find_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerzy, dietetycy i fizjoterapeuci z najbliższymi wolnymi godzinami. Konto nie jest potrzebne, żeby się rozejrzeć.`)
};

/**
* | output |
* | --- |
* | "Trainers, dieticians and physios with their next free hours. You do not need an account to look around." |
*
* @param {How_Page_Find_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_find_body = /** @type {((inputs?: How_Page_Find_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Find_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_find_body(inputs)
	return en_how_page_find_body(inputs)
});